import { AlertTriangle } from 'lucide-react';
import { Button, Card, Description, Heading } from '@heroui/react';

interface ReportMisusePromoProps {
  onOpenReport: () => void;
}

export function ReportMisusePromo({ onOpenReport }: ReportMisusePromoProps) {
  return (
    <Card>
      <Card.Content className="flex flex-col items-stretch gap-5 p-5">
        <div className="flex items-start gap-3">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-danger/15 text-danger">
            <AlertTriangle size={20} />
          </div>
          <div>
            <Heading level={3} className="text-base font-semibold">
              Alguém estacionou na sua vaga?
            </Heading>
            <Description>
              Avise os moradores do condomínio. Informe a placa e, se quiser, uma foto do carro
              estacionado indevidamente.
            </Description>
          </div>
        </div>
        <Button variant="danger" size="lg" className="w-full" onPress={onOpenReport}>
          <AlertTriangle size={18} />
          Reportar mau uso
        </Button>
      </Card.Content>
    </Card>
  );
}
